import React from 'react';

const MaximizeSVG = ({ color = '#020A58', className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      onClick={onClick}
      className={className}
      {...props}
    >
      <path
        d='M7.84683 11.4987C8.0609 11.4976 8.2666 11.5818 8.41822 11.7332C8.56963 11.8844 8.65458 12.09 8.65381 12.3043C8.65305 12.5183 8.56697 12.7234 8.4144 12.8736L2.89361 18.3902H7.55661C7.84402 18.3902 8.10952 18.5437 8.25311 18.7926C8.39672 19.0418 8.39672 19.3485 8.25311 19.5976C8.10951 19.8466 7.84401 20 7.55661 20H0.90124C0.746016 19.987 0.597647 19.9293 0.474613 19.8334C0.423569 19.8019 0.376338 19.7646 0.333865 19.7225C0.208544 19.5778 0.138836 19.3931 0.137695 19.2015V12.5621C0.137695 12.2744 0.290822 12.0089 0.539753 11.865C0.788493 11.7213 1.09515 11.7213 1.34386 11.865C1.59279 12.0089 1.74592 12.2744 1.74592 12.5621V17.2589L7.27939 11.7335C7.43004 11.5831 7.63402 11.4986 7.84678 11.4986L7.84683 11.4987ZM19.3272 0H12.7357C12.4483 0 12.1828 0.153445 12.0392 0.402392C11.8956 0.65153 11.8956 0.958249 12.0392 1.20736C12.1828 1.45631 12.4483 1.60975 12.7357 1.60975H17.3987L11.8779 7.13075C11.6753 7.33376 11.5961 7.62941 11.6703 7.90654C11.7446 8.18369 11.9608 8.40003 12.2377 8.4744C12.5147 8.54874 12.81 8.46944 13.0129 8.26662L18.5293 2.74124V7.43804C18.5293 7.72568 18.6826 7.99121 18.9313 8.13511C19.1803 8.27884 19.4867 8.27884 19.7356 8.13511C19.9844 7.9912 20.1377 7.72567 20.1377 7.43804V0.806892C20.1371 0.603884 20.0598 0.408887 19.9211 0.260795C19.7827 0.112684 19.5934 0.0225251 19.3911 0.00841766H19.3271L19.3272 0Z'
        fill={color}
      />
    </svg>
  );
};

export default MaximizeSVG;
